/** Tokens visuais — orçamento / solicitações (marca TNV) */
export const ORCAMENTO_ACCENT = "#F96030";
export const ORCAMENTO_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";
export const ORCAMENTO_INK = "#1a2035";

export const solicitacoesToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${ORCAMENTO_ACCENT}`,
};

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 980,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  background: `linear-gradient(135deg, ${ORCAMENTO_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${ORCAMENTO_ACCENT}`,
};

export const sectionCardSx = {
  p: 2.5,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
};
